import { Button, Flex } from "@theorgchartdev/storybook";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { enumUIModes } from "@coreapp/constants";
import { Globals } from "@coreapp/CoreApp/Globals";
import { QCmd } from "@coreapp/CoreApp/QCmd";

const FinishBoxLayoutEditButton = () => {
  const editingLayout = Globals._uiConfig.GetUIMode() === enumUIModes.boxlayouteditor;
  const wsMgr = GetWSMgr();
  const layoutPanel = wsMgr?.fLayoutPanel;
  if (!editingLayout || !layoutPanel) return;

  const executeCmd = cmdCode => {
    const cmd = new QCmd();
    cmd.fWSMgr = wsMgr;
    cmd.fCmdCode = cmdCode;
    cmd.fSourcePanel = layoutPanel;
    wsMgr.DoExecuteCommand(cmd);
  };

  return (
    <Flex gap="8px">
      <Button
        dataTestId="cancel-box-layout-edit-button"
        onClick={() => executeCmd("CancelBoxLayout")}
        modifier="secondary"
        type="button"
      >
        {appstr("Cancel")}
      </Button>
      <Button
        dataTestId="save-box-layout-edit-button"
        onClick={() => executeCmd("OKBoxLayout")}
        modifier="primary"
        type="button"
      >
        {appstr("Save changes")}
      </Button>
    </Flex>
  );
};

export default FinishBoxLayoutEditButton;
